import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  Box,
  Button,
  MenuItem,
  Link,
  Divider
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Menu, { MenuProps } from "@mui/material/Menu";
import LogoutIcon from "@mui/icons-material/Logout";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import HomeIcon from "@mui/icons-material/Home";
import AlertPopup from "../components/AlertPopup";

// Import logo
import logo from "../assets/logo.png";

const admin_string = process.env.REACT_APP_ADMIN_URL || "/t31u4YYky50K";
const domain_name = process.env.REACT_APP_DOMAIN_URL || "https://r3play.com";

const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 160,
    color: theme.palette.mode === "light" ? "rgb(55, 65, 81)" : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      fontSize: 16,
      "& .MuiSvgIcon-root": {
        fontSize: 24,
        marginRight: theme.spacing(1.5),
      },
    },
  },
}));

const StyledToolbar = styled("Toolbar")({
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: "#fff",
});

const StyledAppBar = styled("AppBar")({
    backgroundColor: "#fff",
    justifyContent: "center",
});

export default function AdminHeader() {
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [popupConfig, setPopupConfig] = useState({
    title: "",
    message: "",
    showCheckCircle: false,
    confirmText: "Close",
    cancelText: "CANCEL",
    onConfirm: null,
  });
  
  let email = localStorage.getItem("email") ? localStorage.getItem("email") : null;
  let userName = localStorage.getItem("userName") ? localStorage.getItem("userName") : "";
  let role = localStorage.getItem("role") ? localStorage.getItem("role") : null;
  const path = location.pathname;
    
  /// detect admin panel and authentication
  useEffect(() => {
    if (location.pathname.includes("signin")) {
      setIsAuthenticated(false);
    } else {
      setIsAuthenticated(true);
    }
    if(path.includes(admin_string) && role && role != "Admin"){
      setPopupConfig({
              title: "Wait a minute! You are in the wrong place. Start from " + domain_name,
              message: "",
              showCheckCircle: false,
              confirmText: "OK",
              cancelText: null,
              onConfirm: null,
            });
      setShowPopup(true);
    }
  }, [location]);
  
  /// Menu
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  useEffect(() => {
    setAnchorEl(null);
  }, [window.innerWidth]);

  // Close on page scroll
  useEffect(() => {
    const handleScroll = () => {
      if (open) {
        handleClose();
      }
    };

    if (open) {
      document.addEventListener("scroll", handleScroll, true);
    }
    return () => {
      document.removeEventListener("scroll", handleScroll, true);
    };
  }, [open]);
  
  const displayDesktop = () => {
  return (
      <Box
        sx={{
          backgroundColor: "white",
          borderBottom: "1px solid #E0E0E0",
          py: 2,
          px: "45px",
          position: "relative",
        }}
      >
      <StyledToolbar>
          {/* Logo */}
          <Box
            component="img"
            src={logo}
            alt="R3PLAY Logo"
            sx={{
              height: "50px",
              width: "161px",
            }}
          />
        <div
          style={{
            width: "100%",
            display: "flex",
          }}
        >
          {isAuthenticated && getMenuButtons()}
        </div>
      </StyledToolbar>
      </Box>
    );
  }

  const getMenuButtons = () => {
    return (
      <>
        <Box style={{ width: 1160 }}></Box>
        <Box
          style={{
            display: "inline-flex",
            flexDirection: "row",
            padding: "10px 0px"
          }}
        >
            <Box>
              <Button
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                variant="contained"
                onClick={handleClick}
                sx={{
                    paddingLeft: 3,
                    paddingRight: 3,
                    marginRight: 3,
                    //width: 300,
                    textTransform: "none",
                    backgroundColor: "#EF5658",
                    "& .MuiButton-startIcon": {
                      marginRight: 1,
                    },
                    "& .MuiButton-endIcon": {
                      marginRight: 1,
                    },
                    "&:hover": {
                      backgroundColor: "#D33338",
                    },
                }}
                disableElevation
                {...{
                  key: "fullName",
                  style: { textTransform: "none" },
                  startIcon: <PersonOutlineIcon />,
                  endIcon: open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />,
                }}
              >
                {userName}
              </Button>
              <StyledMenu
                id="demo-customized-menu"
                MenuListProps={{
                  "aria-labelledby": "demo-customized-button",
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                disableScrollLock
              >
                <Link
                  {...{
                    component: RouterLink,
                    to: (`${admin_string}/dashboard/`),
                    color: "inherit",
                    style: { textDecoration: "none" },
                    key: "dashboard",
                  }}
                >
                  <MenuItem onClick={handleClose} disableRipple>
                    <HomeIcon />
                    Dashboard
                  </MenuItem>
                </Link>
                <Divider sx={{ my: 0.5 }} />
                
                <Link
                  {...{
                    component: RouterLink,
                    to: (`${admin_string}/profile/`),
                    color: "inherit",
                    style: { textDecoration: "none" },
                    key: "profile",
                  }}
                >
                  <MenuItem onClick={handleClose} disableRipple>
                    <PersonOutlineIcon />
                    Profile
                  </MenuItem>
                </Link>

                <Divider sx={{ my: 0.5 }} />
                <Link
                  {...{
                    component: RouterLink,
                    to: (`${admin_string}/signout/`),
                    color: "inherit",
                    style: { textDecoration: "none" },
                    key: "signout",
                  }}
                >
                  <MenuItem onClick={handleClose} disableRipple>
                    <LogoutIcon color="error" />
                    Sign Out
                  </MenuItem>
                </Link>
              </StyledMenu>
            </Box>
        </Box>
      </>
    );
  };
  return (
    <>
    <header>
      <StyledAppBar>
        {displayDesktop()}
        <AlertPopup
          open={showPopup}
          onClose={() => setShowPopup(false)}
          title={popupConfig.title}
          message={popupConfig.message}
          showCheckCircle={popupConfig.showCheckCircle}
          confirmText={popupConfig.confirmText}
          cancelText={popupConfig.cancelText}
          onConfirm={popupConfig.onConfirm}
        />
      </StyledAppBar>
    </header>
    </>
  );
}
